import { finectAPI } from '@finect/front-utils/finectAPI';
export var sendEvent = function sendEvent(payload) {
  return finectAPI({
    version: 'events',
    path: "",
    credentials: true,
    method: 'POST',
    body: payload
  });
};